// Giá trị mặc định là cấu hình chạy local. Môi trường triển khai override qua
// REACT_APP_OAUTH_* (ưu tiên) hoặc REACT_APP_SSO_*/REACT_APP_API_URL trong .env
// (CRA nhúng lúc build, không đọc được lúc chạy).
const ssoBaseUrl = (
    process.env.REACT_APP_OAUTH_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    'http://localhost:8080/'
).replace(/\/+$/, '');

const redirectUri =
    process.env.REACT_APP_OAUTH_REDIRECT_URI ||
    process.env.REACT_APP_SSO_LOGIN_CALLBACK ||
    'http://localhost:3000/loginCallback';

export const AUTH_CONFIG = {
    ssoBaseUrl,
    clientId:
        process.env.REACT_APP_OAUTH_CLIENT_ID ||
        process.env.REACT_APP_SSO_CLIENT_ID ||
        'test-client',
    clientSecret: process.env.REACT_APP_SSO_CLIENT_SECRET || 'test-secret',
    redirectUri,
    scope: process.env.REACT_APP_OAUTH_SCOPE || 'openid profile email',

    // Endpoints
    get authorizeUrl() { return `${this.ssoBaseUrl}/oauth/authorize`; },
    get tokenUrl() { return `${this.ssoBaseUrl}/oauth/token`; },
    get loginUrl() { return `${this.ssoBaseUrl}/api/auth/ssoLogin`; },
    get logoutUrl() { return `${this.ssoBaseUrl}/api/auth/ssoLogout`; },
    get resetPassword() { return `${this.ssoBaseUrl}/api/auth/forgotPassword`; },
    get userinfoUrl() { return `${this.ssoBaseUrl}/oauth/userinfo`; },

    // Đăng nhập qua Hệ thống định danh điện tử (3A/DMDC - VNeID)
    get dmdcAuthorizeUrl() { return `${this.ssoBaseUrl}/api/auth/external/dmdc/authorize-url`; },
    get dmdcCallbackUrl() { return `${this.ssoBaseUrl}/api/auth/external/dmdc/callback`; },
    get dmdcLinkUrl() { return `${this.ssoBaseUrl}/api/auth/external/dmdc/link`; },
    get dmdcLinkAuthorizeUrl() { return `${this.ssoBaseUrl}/api/auth/external/dmdc/link-authorize-url`; },
};
